import { Component, inject } from '@angular/core';
import { PropertyNurseryVendorService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PropertyNurseryVendorCreateDto,
  PropertyNurseryVendorDto,
  PropertyNurseryVendorExcelDownloadDto,
  PropertyNurseryVendorUpdateDto,
} from '../proxy/controlling/dtos/property-nursery-vendor';
import { PROPERTYNURSERYVENDOR_CONFIG, PROPERTYNURSERYVENDOR_FIELDS } from './property-nursery-vendor.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-property-nursery-vendor',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm
  ],
  providers: [ListService, PropertyNurseryVendorService, ConfirmationService],
  templateUrl: './property-nursery-vendor.html',
  styleUrl: './property-nursery-vendor.scss',
})
export class PropertyNurseryVendor extends BaseHierarchicalCrudComponent<
  PropertyNurseryVendorDto,
  PropertyNurseryVendorCreateDto,
  PropertyNurseryVendorUpdateDto,
  PropertyNurseryVendorExcelDownloadDto
> {
  service = inject(PropertyNurseryVendorService);
  config = PROPERTYNURSERYVENDOR_CONFIG;
  fields = PROPERTYNURSERYVENDOR_FIELDS;

  protected prepareUpdateDto(data: any, selected: PropertyNurseryVendorDto): PropertyNurseryVendorUpdateDto {
    return {
      vendorId: data.vendorId,
      propertyLocationId: data.propertyLocationId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PropertyNurseryVendor';
  }
}
